import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import MarketCourseService from "../../services/MarketCourseService";

/**
 * Курсы витрины корпоративного обучения для публичных страниц /courses и /courses/:slug.
 *
 * Список грузится целиком одним запросом и лежит в сторе: курсов около десятка,
 * а каталогу всё равно нужны они все — для поиска по темам модулей, счётчиков
 * в фильтрах и блока «Похожие программы». Отдельный запрос на карточку курса
 * поэтому не нужен: страница курса берёт его из того же списка по слагу.
 */
const initialState = {
    courses: [],
    isLoading: false,
    /** true — список хотя бы раз успешно загружен; отличает «пусто» от «ещё не грузили» */
    isLoaded: false,
    error: null,
};

export const getMarketCourses = createAsyncThunk(
    'getMarketCourses',
    async (_, {rejectWithValue}) => {
        try {
            return await MarketCourseService.getAll();
        } catch (error) {
            return rejectWithValue(error?.response?.data || 'network error');
        }
    },
);

const marketCoursesSlice = createSlice({
    name: 'marketCoursesSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getMarketCourses.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getMarketCourses.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isLoaded = true;
                state.courses = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getMarketCourses.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.courses = [];
            });
    },
});

/** Видимые курсы в редакторском порядке. Бэкенд уже фильтрует и сортирует, но
 *  порядок дублируем на клиенте: список ещё раз сортируется после правок в админке. */
export const selectVisibleCourses = (state) =>
    [...(state.marketCourses?.courses || [])]
        .filter((c) => c.visible !== false)
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

export const selectCourseBySlug = (slug) => (state) =>
    (state.marketCourses?.courses || []).find((c) => c.slug === slug);

export default marketCoursesSlice.reducer;
